import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router';
import { ArrowLeft, DollarSign, CreditCard, Gift, TrendingUp, FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../utils/currency';
import { Project } from '../types';
import { getProject as getProjectAPI } from '../utils/api';
import {
  calculateLoan,
  calculateFinancingScenario,
  getIncentivesByCountry,
  calculateIncentiveValue,
  calculateTaxBenefits,
  getCountryCodeFromLocation,
  FinancingScenario,
  Incentive,
  TaxBenefit,
} from '../utils/financing';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Slider } from '../components/ui/slider';
import { Badge } from '../components/ui/badge';
import { formatPercent } from '../utils/formatters';
import { DecimalInput } from '../components/DecimalInput';
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { LoadingSpinner } from '../components/LoadingSpinner';

export function FinancingPage() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [project, setProject] = useState<Project | null>(null);
}